export default "__VITE_ASSET__e311d3be__"